"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCreateRequestMetaOptions = getCreateRequestMetaOptions;
exports.resourceDeleteFailure = exports.resourceDeleteSuccess = exports.resourceDeleteRequest = exports.RESOURCE_DELETE_FAILURE = exports.RESOURCE_DELETE_SUCCESS = exports.RESOURCE_DELETE_REQUEST = exports.resourceUpdateFailure = exports.resourceUpdateSuccess = exports.resourceUpdateRequest = exports.RESOURCE_UPDATE_FAILURE = exports.RESOURCE_UPDATE_SUCCESS = exports.RESOURCE_UPDATE_REQUEST = exports.resourceDetailReadFailure = exports.resourceDetailReadSuccess = exports.resourceDetailReadRequest = exports.RESOURCE_DETAIL_READ_FAILURE = exports.RESOURCE_DETAIL_READ_SUCCESS = exports.RESOURCE_DETAIL_READ_REQUEST = exports.resourceListReadFailure = exports.resourceListReadSuccess = exports.resourceListReadRequest = exports.RESOURCE_LIST_READ_FAILURE = exports.RESOURCE_LIST_READ_SUCCESS = exports.RESOURCE_LIST_READ_REQUEST = exports.resourceListCreateFailure = exports.resourceListCreateSuccess = exports.resourceListCreateRequest = exports.RESOURCE_LIST_CREATE_FAILURE = exports.RESOURCE_LIST_CREATE_SUCCESS = exports.RESOURCE_LIST_CREATE_REQUEST = exports.resourceCreateFailure = exports.resourceCreateSuccess = exports.resourceCreateRequest = exports.RESOURCE_CREATE_FAILURE = exports.RESOURCE_CREATE_SUCCESS = exports.RESOURCE_CREATE_REQUEST = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _utils = require("../../utils");

var optionsDefault = {
  autoCaseKeys: true
};

function getCreateRequestMetaOptions(options) {
  if (!(0, _utils.isPlainObject)(options)) {
    return (0, _extends2.default)({}, optionsDefault);
  }

  return (0, _extends2.default)({}, optionsDefault, options);
} // --
// -- ACTIONS
// --


var RESOURCE_CREATE_REQUEST = 'RESOURCE_CREATE_REQUEST';
exports.RESOURCE_CREATE_REQUEST = RESOURCE_CREATE_REQUEST;
var RESOURCE_CREATE_SUCCESS = 'RESOURCE_CREATE_SUCCESS';
exports.RESOURCE_CREATE_SUCCESS = RESOURCE_CREATE_SUCCESS;
var RESOURCE_CREATE_FAILURE = 'RESOURCE_CREATE_FAILURE';
exports.RESOURCE_CREATE_FAILURE = RESOURCE_CREATE_FAILURE;

var resourceCreateRequest = function (resource, data, entityType, options) {
  return {
    type: RESOURCE_CREATE_REQUEST,
    payload: {
      data
    },
    meta: (0, _extends2.default)({
      resource,
      entityType,
      thunk: {
        name: `${resource}Create`
      }
    }, getCreateRequestMetaOptions(options))
  };
};

exports.resourceCreateRequest = resourceCreateRequest;

var resourceCreateSuccess = function (resource, entityType, payload, request, thunk) {
  return {
    type: RESOURCE_CREATE_SUCCESS,
    payload: (0, _extends2.default)({}, payload, {
      resource: {
        path: resource
      },
      entityType
    }),
    meta: {
      request,
      thunk,
      resource,
      entityType,
      normalizeEntities: true
    }
  };
};

exports.resourceCreateSuccess = resourceCreateSuccess;

var resourceCreateFailure = function (resource, entityType, error, request, thunk) {
  return {
    type: RESOURCE_CREATE_FAILURE,
    error: true,
    payload: error,
    meta: {
      request,
      resource,
      entityType,
      thunk
    }
  };
};

exports.resourceCreateFailure = resourceCreateFailure;
var RESOURCE_LIST_CREATE_REQUEST = 'RESOURCE_LIST_CREATE_REQUEST';
exports.RESOURCE_LIST_CREATE_REQUEST = RESOURCE_LIST_CREATE_REQUEST;
var RESOURCE_LIST_CREATE_SUCCESS = 'RESOURCE_LIST_CREATE_SUCCESS';
exports.RESOURCE_LIST_CREATE_SUCCESS = RESOURCE_LIST_CREATE_SUCCESS;
var RESOURCE_LIST_CREATE_FAILURE = 'RESOURCE_LIST_CREATE_FAILURE';
exports.RESOURCE_LIST_CREATE_FAILURE = RESOURCE_LIST_CREATE_FAILURE;

var resourceListCreateRequest = function (resource, data, entityType, options) {
  return {
    type: RESOURCE_LIST_CREATE_REQUEST,
    payload: {
      data
    },
    meta: (0, _extends2.default)({
      resource,
      entityType,
      thunk: {
        name: `${resource}ListCreate`
      }
    }, getCreateRequestMetaOptions(options))
  };
};

exports.resourceListCreateRequest = resourceListCreateRequest;

var resourceListCreateSuccess = function (resource, entityType, payload, request, thunk) {
  return {
    type: RESOURCE_LIST_CREATE_SUCCESS,
    payload: (0, _extends2.default)({}, payload, {
      resource: {
        path: resource
      },
      entityType
    }),
    meta: {
      request,
      thunk,
      resource,
      entityType,
      normalizeEntities: true
    }
  };
};

exports.resourceListCreateSuccess = resourceListCreateSuccess;

var resourceListCreateFailure = function (resource, entityType, error, request, thunk) {
  return {
    type: RESOURCE_LIST_CREATE_FAILURE,
    error: true,
    payload: error,
    meta: {
      request,
      entityType,
      thunk,
      resource
    }
  };
};

exports.resourceListCreateFailure = resourceListCreateFailure;
var RESOURCE_LIST_READ_REQUEST = 'RESOURCE_LIST_READ_REQUEST';
exports.RESOURCE_LIST_READ_REQUEST = RESOURCE_LIST_READ_REQUEST;
var RESOURCE_LIST_READ_SUCCESS = 'RESOURCE_LIST_READ_SUCCESS';
exports.RESOURCE_LIST_READ_SUCCESS = RESOURCE_LIST_READ_SUCCESS;
var RESOURCE_LIST_READ_FAILURE = 'RESOURCE_LIST_READ_FAILURE';
exports.RESOURCE_LIST_READ_FAILURE = RESOURCE_LIST_READ_FAILURE;

var resourceListReadRequest = function (resource, params, entityType, options) {
  return {
    type: RESOURCE_LIST_READ_REQUEST,
    payload: {
      params
    },
    meta: (0, _extends2.default)({
      resource,
      entityType,
      thunk: {
        name: `${resource}ListRead`
      }
    }, getCreateRequestMetaOptions(options))
  };
};

exports.resourceListReadRequest = resourceListReadRequest;

var resourceListReadSuccess = function (resource, entityType, payload, request, thunk) {
  return {
    type: RESOURCE_LIST_READ_SUCCESS,
    payload: (0, _extends2.default)({}, payload, {
      resource: {
        path: resource
      },
      entityType
    }),
    meta: {
      request,
      thunk,
      resource,
      entityType,
      normalizeEntities: true
    }
  };
};

exports.resourceListReadSuccess = resourceListReadSuccess;

var resourceListReadFailure = function (resource, entityType, error, request, thunk) {
  return {
    type: RESOURCE_LIST_READ_FAILURE,
    error: true,
    payload: error,
    meta: {
      request,
      entityType,
      thunk,
      resource
    }
  };
};

exports.resourceListReadFailure = resourceListReadFailure;
var RESOURCE_DETAIL_READ_REQUEST = 'RESOURCE_DETAIL_READ_REQUEST';
exports.RESOURCE_DETAIL_READ_REQUEST = RESOURCE_DETAIL_READ_REQUEST;
var RESOURCE_DETAIL_READ_SUCCESS = 'RESOURCE_DETAIL_READ_SUCCESS';
exports.RESOURCE_DETAIL_READ_SUCCESS = RESOURCE_DETAIL_READ_SUCCESS;
var RESOURCE_DETAIL_READ_FAILURE = 'RESOURCE_DETAIL_READ_FAILURE';
exports.RESOURCE_DETAIL_READ_FAILURE = RESOURCE_DETAIL_READ_FAILURE;

var resourceDetailReadRequest = function (resource, needle, params, entityType, options) {
  return {
    type: RESOURCE_DETAIL_READ_REQUEST,
    payload: {
      needle,
      params
    },
    meta: (0, _extends2.default)({
      entityType,
      resource,
      thunk: {
        name: `${resource}DetailRead`
      }
    }, getCreateRequestMetaOptions(options))
  };
};

exports.resourceDetailReadRequest = resourceDetailReadRequest;

var resourceDetailReadSuccess = function (resource, entityType, payload, request, thunk) {
  return {
    type: RESOURCE_DETAIL_READ_SUCCESS,
    payload: (0, _extends2.default)({}, payload, {
      resource: {
        path: resource
      },
      entityType
    }),
    meta: {
      request,
      thunk,
      resource,
      entityType,
      normalizeEntities: true
    }
  };
};

exports.resourceDetailReadSuccess = resourceDetailReadSuccess;

var resourceDetailReadFailure = function (resource, entityType, error, request, thunk) {
  return {
    type: RESOURCE_DETAIL_READ_FAILURE,
    error: true,
    payload: error,
    meta: {
      entityType,
      request,
      thunk,
      resource
    }
  };
};

exports.resourceDetailReadFailure = resourceDetailReadFailure;
var RESOURCE_UPDATE_REQUEST = 'RESOURCE_UPDATE_REQUEST';
exports.RESOURCE_UPDATE_REQUEST = RESOURCE_UPDATE_REQUEST;
var RESOURCE_UPDATE_SUCCESS = 'RESOURCE_UPDATE_SUCCESS';
exports.RESOURCE_UPDATE_SUCCESS = RESOURCE_UPDATE_SUCCESS;
var RESOURCE_UPDATE_FAILURE = 'RESOURCE_UPDATE_FAILURE';
exports.RESOURCE_UPDATE_FAILURE = RESOURCE_UPDATE_FAILURE;

var resourceUpdateRequest = function (resource, needle, data, entityType, options) {
  return {
    type: RESOURCE_UPDATE_REQUEST,
    payload: {
      needle,
      data
    },
    meta: (0, _extends2.default)({
      entityType,
      resource,
      thunk: {
        name: `${resource}Update`
      }
    }, getCreateRequestMetaOptions(options))
  };
};

exports.resourceUpdateRequest = resourceUpdateRequest;

var resourceUpdateSuccess = function (resource, entityType, payload, request, thunk) {
  return {
    type: RESOURCE_UPDATE_SUCCESS,
    payload: (0, _extends2.default)({}, payload, {
      resource: {
        path: resource
      },
      entityType
    }),
    meta: {
      request,
      thunk,
      resource,
      entityType,
      normalizeEntities: true
    }
  };
};

exports.resourceUpdateSuccess = resourceUpdateSuccess;

var resourceUpdateFailure = function (resource, entityType, error, request, thunk) {
  return {
    type: RESOURCE_UPDATE_FAILURE,
    error: true,
    payload: error,
    meta: {
      entityType,
      request,
      thunk,
      resource
    }
  };
};

exports.resourceUpdateFailure = resourceUpdateFailure;
var RESOURCE_DELETE_REQUEST = 'RESOURCE_DELETE_REQUEST';
exports.RESOURCE_DELETE_REQUEST = RESOURCE_DELETE_REQUEST;
var RESOURCE_DELETE_SUCCESS = 'RESOURCE_DELETE_SUCCESS';
exports.RESOURCE_DELETE_SUCCESS = RESOURCE_DELETE_SUCCESS;
var RESOURCE_DELETE_FAILURE = 'RESOURCE_DELETE_FAILURE';
exports.RESOURCE_DELETE_FAILURE = RESOURCE_DELETE_FAILURE;

var resourceDeleteRequest = function (resource, needle, entityType, options) {
  return {
    type: RESOURCE_DELETE_REQUEST,
    payload: {
      needle
    },
    meta: (0, _extends2.default)({
      entityType,
      resource,
      thunk: {
        name: `${resource}Delete`
      }
    }, getCreateRequestMetaOptions(options))
  };
};

exports.resourceDeleteRequest = resourceDeleteRequest;

var resourceDeleteSuccess = function (resource, entityType, payload, request, thunk, updateEntities) {
  return {
    type: RESOURCE_DELETE_SUCCESS,
    payload: (0, _extends2.default)({}, payload, {
      resource: {
        path: resource
      },
      entityType
    }),
    meta: {
      request,
      thunk,
      resource,
      entityType,
      removeEntities: !updateEntities,
      normalizeEntities: updateEntities
    }
  };
};

exports.resourceDeleteSuccess = resourceDeleteSuccess;

var resourceDeleteFailure = function (resource, entityType, error, request, thunk) {
  return {
    type: RESOURCE_DELETE_FAILURE,
    error: true,
    payload: error,
    meta: {
      entityType,
      request,
      thunk,
      resource
    }
  };
};

exports.resourceDeleteFailure = resourceDeleteFailure;